<template>

    <div class="room-booking-summary">

        <div class="has-shadow panel panel--primary">
            <div class="row">
                <div class="col-24">
                    <div class="room-leg-wrapper">
                        <h3 class="mb-0">Room {{room.Leg}}:<span v-if="room.IsCancelled">Cancelled</span></h3>

                    </div>

                    <div class="room-detail-wrapper">
                        <div class="room-detail-section room-detail-section--shallow">
                            <h4 class="title">Room, Rate &amp; Add Ons:</h4>

                            <div class="room-detail-item">
                                <div class="row ">
                                    <div class="col-8">
                                        <span class="info-title">Guests:</span>
                                    </div>
                                    <div class="col-16">
                                        {{formatGuests(room.GuestQuota)}}
                                    </div>


                                </div>
                                <!--<button class="edit">Edit</button>-->
                            </div>



                            <div class="room-detail-item" v-if="room.GuestQuota.Dogs">
                                <div class="row ">
                                    <div class="col-8">
                                        <span class="info-title">Dogs:</span>
                                    </div>
                                    <div class="col-16">
                                        {{room.GuestQuota.Dogs}}  {{room.GuestQuota.Dogs == 1 ? 'dog' : 'dogs'}}
                                    </div>


                                </div>
                                <!--<button class="edit">Edit</button>-->
                            </div>


                            <div class="room-detail-item">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Room type:</span>
                                    </div>
                                    <div class="col-16">
                                        {{getRoomType(room.RoomCode)}}
                                    </div>
                                </div>
                                <!--<button class="edit">Edit</button>-->

                            </div>


                            <div class="room-detail-item">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Rate:</span>
                                    </div>
                                    <div class="col-16">
                                        {{getRateType(room.RateCode)}}
                                    </div>
                                </div>
                                <!--<button class="edit">Edit</button>-->
                            </div>



                            <div class="room-detail-item" v-if="getAddons().length">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Add ons:</span>
                                    </div>
                                    <div class="col-16">
                                        <ul class="guest-names">
                                            <li v-bind:key="index"
                                                v-for="(addOn, index) in getAddons()">

                                                {{addOn.quantity > 1 ? addOn.quantity + ' x ' + addOn.content?.DisplayName : addOn.content?.DisplayName}}
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                        </div>


                        <div class="room-detail-section room-detail-section--shallow">
                            <h4 class="title">Room 1 Receipt:</h4>
                            <div class="room-detail-item">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Room &amp; rate:</span>
                                    </div>
                                    <div class="col-16">
                                        <strong>&pound;{{priceFormatted(room.Total - room.PackagesTotal)}}</strong>
                                    </div>
                                </div>

                            </div>

                            <div class="room-detail-item" v-if="room.NonAdultTotal> 0">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Children &amp; Infants:</span>
                                    </div>
                                    <div class="col-16">
                                        <strong>&pound;{{priceFormatted(room.NonAdultTotal)}}</strong>
                                    </div>
                                </div>

                            </div>

                            <div class="room-detail-item" v-if="room.DogsTotal> 0">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Dogs:</span>
                                    </div>
                                    <div class="col-16">
                                        <strong>&pound;{{priceFormatted(room.DogsTotal)}}</strong>
                                    </div>
                                </div>

                            </div>

                            <div class="room-detail-item" v-if="room.PackagesTotal> 0">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Add ons:</span>
                                    </div>
                                    <div class="col-16">
                                        <strong>&pound;{{priceFormatted(room.PackagesTotal)}}</strong>
                                    </div>
                                </div>

                            </div>

                            <div class="room-detail-item">
                                <div class="row mb-1">
                                    <div class="col-8">
                                        <span class="info-title">Rate:</span>
                                    </div>
                                    <div class="col-16">
                                        <strong>{{room.RequiresDeposit ? 'Advanced purchase' : 'Flexible rate'}}</strong>

                                        <p v-if="!room.IsCancelled">{{cancellationTime(room.CancellationDateTime)}}</p>
                                    </div>
                                </div>

                            </div>




                        </div>


                        <div class="mt-4" v-if="!room.IsCancelled">
                            <div v-if="room.RequiresDeposit">
                                <info-box v-bind:type="'success'">
                                    <template v-slot:body>
                                        <span class="heading">
                                            Your payment has been authorised
                                        </span>

                                        <div>
                                            <p>
                                                <span v-if="room.PaymentCard != null && room.PaymentCard.length">Payment will be taken from card ending {{room.PaymentCard}}.</span>  Please note transactions can take up to 24 hours to process.
                                            </p>
                                        </div>
                                    </template>
                                </info-box>
                            </div>
                            <div v-if="!room.RequiresDeposit">
                                <info-box v-bind:type="'alert'">
                                    <template v-slot:body>
                                        <span class="heading">
                                            Payment due on arrival
                                        </span>

                                        <div>

                                            <ul>
                                                <li>A credit card guarantee will be taken on the lead booker's card to secure your booking</li>
                                            </ul>
                                        </div>
                                    </template>
                                </info-box>
                            </div>
                        </div>


                    </div>
                    <div class="room-detail-wrapper">
                        <div class="room-detail-section room-detail-section--shallow pt-0 ">

                            <div class="room-detail-section pt-0 pb-0">
                                <h4 class="title">Guests</h4>

                                <div class="room-detail-item">
                                    <div class="row mb-1">
                                        <div class="col-8">
                                            <span class="info-title">Names:</span>
                                        </div>
                                        <div class="col-16">
                                            <ul class="guest-names">
                                                <li v-bind:key="index"
                                                    v-for="(guest, index) in room.GuestNames">
                                                    {{guest}}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="room-detail-wrapper spa-itinerary" v-if="room.SpaReservation != null">
                        <div class="room-detail-section room-detail-section--shallow pt-0">

                            <div class="room-detail-section pt-0">
                                <h3>Your Spa Itinerary</h3>
                                <div class="row">
                                    <div class="col-24">

                                        <info-box v-bind:type="'alert'">
                                            <template v-slot:body>
                                                <div class="d-flexf flex-column justify-content-between">
                                                    <span class="heading">
                                                        Times here are requests only
                                                    </span>
                                                    <p>
                                                        The reservations team will be in touch to confirm shortly
                                                    </p>


                                                </div>
                                            </template>
                                        </info-box>


                                    </div>
                                </div>


                                <div class="row mt-4">
                                    <div class="col-12  mb-4" v-for="(guest, guestIndex) in getGuests(room) " v-if="getGuestItinerary(room, guestIndex)">
                                        <h3 class="mb-3">{{guest.FirstName}}'s itinerary</h3>

                                        <ul>


                                            <li class="item d-flex" v-for="(spaItem, spaItemIndex) in getGuestItinerary(room, guestIndex)">
                                                <span class="time">{{formatDateTime(spaItem.StartDateTime)}}</span>
                                                <span class="treatment d-inline-flex">{{spaItem.DisplayName}}</span>
                                            </li>

                                        </ul>



                                    </div>


                                </div>


                            </div>




                        </div>
                    </div>
                </div>







            </div>
        </div>

    </div>
</template>

<script>
    import { accountStore } from '../store/index';
    import InfoBox from '@/shared/components/InfoBox.vue';
    import { _ } from 'vue-underscore';
    export default {
        name: 'RoomBookingSummary',
        props: {
            room: Object,


        },
        components: {
            InfoBox
        },
        computed: {

            configuration() {
                return accountStore.getters.accountConfiguration;
            },
           
        },
        methods: {
            getGuests(input) {
                let result = [];

                result.push(input.LeadGuest);
                result.push(...input.AccompanyingGuests);
                return result;
            },
            getGuestItinerary(room, index) {
                let result = [];

                let spa = room.SpaReservation.Items.filter(item => item.ClientIndex == index);

                for (var i = 0; i < spa.length; i++) {
                    var it = spa[i];

                    result.push({
                        StartDateTime: it.StartDateTime,
                        DisplayName: it.DisplayName
                    })

                }

                return _.sortBy(result, function (item) {
                    return moment(item.StartTime, "HH:mm")
                });

        
                


            },
            formatGuests(guestCount) {
                let result = "";


                if (guestCount.Adults == 1) {
                    result += "1 adult"
                }
                if (guestCount.Adults > 1) {
                    result += guestCount.Adults + ' adults';
                }



                if (guestCount.Adults > 0 && guestCount.Children > 0 && guestCount.Infants == 0) {
                    result += " & ";
                }
                else if (guestCount.Adults > 0 && guestCount.Children > 0 && guestCount.Infants > 0) {
                    result += " , ";
                }


                if (guestCount.Children > 0) {

                    if (guestCount.Children == 1) {
                        result += "1 child";
                    }
                    if (guestCount.Children > 1) {
                        result += guestCount.Children + ' children';
                    }

                }


                if (guestCount.Infants > 0) {
                    result += " & ";
                    if (guestCount.Infants == 1) {
                        result += "1 infant";
                    }
                    if (guestCount.Infants > 1) {
                        result += guestCount.Infants + ' infants';
                    }

                }


                return result;
            },
            getAddons() {
                let result = [];
                if (this.room.Packages != null) {
                    for (let pi = 0; pi < this.room.Packages.length; pi++) {

                        let pckg = this.room.Packages[pi];
                        let content = this.configuration.AddOns.find(item => item.PMSCode === pckg.Code);

                        result.push({
                            quantity: +(pckg.Quantity),
                            content
                        })

                    }
                }
                return result;
            },
            getRoomType(roomCode) {

                if (this.configuration != null) {


                    let roomType = this.configuration.RoomTypes.find(item => item.PMSCode == roomCode);
                    if (roomType != null) {
                        return roomType.DisplayName;
                    }
                }


                return roomCode;


            },
            getRateType(rateCode) {

                if (this.configuration != null) {


                    let rateType = this.configuration.RateTypes.find(item => item.PMSCode == rateCode);
                    if (rateType != null) {
                        return rateType.DisplayName;
                    }
                }


                return rateCode;


            },
            cancellationTime(date) {
                let result = '';

                let cancellationTime = moment(date).format('ha');
                let cancellationDate = moment(date).format('Do MMMM');

                let requiresDeposit = this.room.RequiresDeposit;

                if (!requiresDeposit) {
                    result += 'Pay on arrival and cancel your stay up to ' + cancellationTime + ' on ' + cancellationDate;
                } else {
                    result += 'Non-refundable however changes can be made until ' + cancellationTime + ' on ' + cancellationDate;
                }
                return result;
            },
            formatDateTime(input) {
                return moment(input).format('HH:mm')
            },
            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            }
        }
    }
</script>
<style src="@/modules/stay/css/components/room-booking-summary.css"></style>
<style scoped>
    ul.guest-names {
        list-style: none;
        padding: 0;
        font-family: "Montserrat";
        font-size: 16px;
        color: #333333;
        line-height: 1.33333;
        font-weight: 400;
    }


    .spa-itinerary .time {
        font-weight: bold;
        width: 80px;
        min-width: 80px;
        display: inline-block;
    }
</style>